import { Directive, Input, ElementRef } from '@angular/core';

@Directive({
    selector: '[agmoAspectRatio]',
    // eslint-disable-next-line @angular-eslint/no-host-metadata-property
    host: {
        '[style.height]': 'calculateHeight()',
    },
    standalone: false
})
export class ImageAspectRatioDirective {
  @Input() agmoAspectRatio: number;

  constructor(private el: ElementRef) {}

  calculateHeight() {
    const width = this.el.nativeElement.clientWidth;
    this.el.nativeElement.style.height = width / this.agmoAspectRatio + 'px';
  }
}
